import { IFormSection, TSubmitType } from "../../types/common";
import { API_DEPARTMENTS, API_REQUISITIONS } from "../../utils/apis";

import { URL_REQUISITIONS } from "../../utils/urls";
import { getAndPrepareFiles, getResultOptions } from "../../utils/helpers";
import { FORM_DATA, MODAL } from "../../utils/constants";
import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";
import useGet from "../common/useGet";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useRequisitionForm = ({ form }) => {
  const [totalEstimatedCost, setTotalEstimatedCost] = useState(0);
  useEffect(() => {
    if (form?.data?.quantity && form?.data?.unit_price) {
      setTotalEstimatedCost(form?.data?.quantity * form?.data?.unit_price);
    }
  }, [form?.data?.quantity, form?.data?.unit_price]);
  const sections: IFormSection[] = [
    {
      title: "Requisition Information",
      fields: [
        {
          field_name: "department",
          type: "select",
          label: "Department",
          props: { required: true },
          options_name: "departments",
        },
        {
          field_name: "requisition_date",
          type: "date",
          label: "Requisition Date",
          props: { required: true },
        },
        {
          field_name: "purpose",
          type: "textarea",
          label: "Purpose",
          props: { required: true, wide: true },
        },
        {
          field_name: "items",
          label: "Items",
          type: MODAL,
          props: { required: true, icon: <Add fontSize="small" />, wide: true },
          fields: [
            {
              field_name: "description",
              type: "textarea",
              label: "Description",
              props: { required: true },
            },
            {
              field_name: "quantity",
              type: "number",
              label: "Quantity",
              props: { required: true },
            },
            {
              field_name: "unit_price",
              type: "number",
              label: "Unit Price",
              props: { required: true },
            },
            {
              field_name: "total_estimated_cost",
              type: "text",
              label: "Total Estimated Cost",
              props: {
                disabled: true,
                value: totalEstimatedCost.toLocaleString(),
              },
              visible: totalEstimatedCost > 0,
            },
          ],
        },
      ],
    },

    {
      title: "Supporting Documents",
      fields: [
        {
          field_name: "attachment",
          type: "file",
          label: "Attachment",
          props: { wide: true },
        },
      ],
    },
  ];

  const redirect = `${URL_REQUISITIONS}`;

  const getConfigOptions = () => {
    const { loadData: getDepartments, data: departments } = useGet();
    // useGet();

    useEffect(() => {
      getDepartments({
        api: API_DEPARTMENTS,
        params: {},
      });
    }, []);

    return {
      departments: getResultOptions(departments, "name", "id"),
    };
  };
  const options = {
    ...getConfigOptions(),
  };

  return { sections, redirect, options };
};

export function submitRequisition(payload: any, id: number | null) {
  const files = ["attachements"];
  let preppedPayload = getAndPrepareFiles(payload, files);
  return {
    api: API_REQUISITIONS,
    id,
    type: FORM_DATA,
    params: preppedPayload,
  };
}
